import moment from 'moment-timezone';
import { Order } from '../../models/Order';
import { OrderFlagType } from '../../types';
import { ROOM_CHARGE_PROVIDER } from './constants';
/** The order's settlement data read as this provider's shape (empty when absent). */
export function roomChargeData(order) {
    // The core keeps settlement_data opaque; only this module knows the shape it stamps.
    return (order.settlement_data ?? {});
}
/**
 * DISPLAY predicate — "was this bill charged to a hotel room?" This provider's
 * charges only: not another provider's, and not the corrective that reverses a
 * charge. Drives room indicators (bed icon, room label); rules use the
 * provider-neutral `Order.isSettledExternally()`.
 */
export function isRoomCharged(order) {
    return order.isChargedExternally() && order.settled_by === ROOM_CHARGE_PROVIDER;
}
/** Display label of the room a bill was charged to, "101 / Guest Name"; '' when not room-charged. */
export function roomChargeLabel(order) {
    if (!isRoomCharged(order))
        return '';
    const { room_name, guest } = roomChargeData(order);
    const room = room_name ?? '';
    return guest ? `${room} / ${guest}` : String(room);
}
/**
 * Stamp an order as charged to a hotel room. One home for the whole transition
 * so every producer stamps the same fields the same way; persistence, peer
 * broadcast and table-session closing stay with the caller. Data comes from
 * the server's result — never from local UI state — so a skipped
 * (already-settled) order keeps its real room. The positional flag is still
 * written for deployed builds that read it; nothing current does.
 */
export function applyRoomCharge(order, data) {
    order.settled_by = ROOM_CHARGE_PROVIDER;
    order.external_synced_at = moment().utc().format(Order.DATE_FORMAT);
    order.settlement_data = data;
    order.setFlag(OrderFlagType.roomCharge, Order.sanitizeFlagValue(data.room_name ? String(data.room_name) : ''), data.id_reservations !== undefined ? String(data.id_reservations) : '', data.id_reservations_rooms !== undefined ? String(data.id_reservations_rooms) : '');
}
//# sourceMappingURL=roomCharge.js.map